module.exports = new __parcel__URL__("board.3d681b47.png").toString();